import React from 'react';
import PropTypes from 'prop-types';

const pathsByVariant = {
  manufacturing: (
    <>
      <rect x='2' y='7' width='6' height='14' />
      <rect x='9' y='3' width='6' height='18' />
      <rect x='16' y='10' width='6' height='11' />
    </>
  ),
  retail: (
    <>
      <circle cx='9' cy='21' r='1' />
      <circle cx='20' cy='21' r='1' />
      <path d='M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6' />
    </>
  ),
  logistics: (
    <>
      <rect x='1' y='3' width='15' height='13' />
      <path d='M16 8h4l3 3v5h-7V8Z' />
      <circle cx='5.5' cy='18.5' r='2.5' />
      <circle cx='18.5' cy='18.5' r='2.5' />
    </>
  ),
  technology: (
    <>
      <path d='m16 18 6-6-6-6' />
      <path d='m8 6-6 6 6 6' />
    </>
  ),
  finance: (
    <>
      <rect x='3' y='10' width='18' height='11' rx='1' />
      <path d='M7 10V6a5 5 0 0 1 10 0v4' />
      <path d='M12 14v4' />
    </>
  ),
  healthcare: <path d='M22 12h-4l-3 9L9 3l-3 9H2' />,
  realEstate: (
    <>
      <path d='m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z' />
      <path d='M9 22V12h6v10' />
    </>
  ),
  consulting: (
    <>
      <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
      <circle cx='9' cy='7' r='4' />
      <path d='M23 21v-2a4 4 0 0 0-3-3.87' />
      <path d='M16 3.13a4 4 0 0 1 0 7.75' />
    </>
  ),
  construction: (
    <>
      <path d='M2 20h20L12 4 2 20Z' />
      <path d='M12 10v4' />
      <path d='M12 17h.01' />
    </>
  ),
  agriculture: (
    <>
      <path d='M2 22c1.25-1.25 2.5-2.5 3.75-2.5C8 19.5 8 22 10.5 22c2.5 0 2.5-2.5 5-2.5 1.25 0 2.5 1.25 3.75 2.5' />
      <path d='M12 13C6.5 13 2 8.5 2 3c3.5 0 6.5 1.5 8.5 4 .75-2 2-3.5 3.5-4.5.5 2 .25 4-.5 5.5 1.5-.5 3-1 4.5-.5-1 2-3 3.5-6 4.5Z' />
    </>
  ),
  energy: <path d='M13 2 3 14h9l-1 8 10-12h-9l1-8Z' />,
  other: (
    <>
      <circle cx='12' cy='12' r='10' />
      <path d='M12 8v4' />
      <path d='M12 16h.01' />
    </>
  ),
};

function IndustryIcon({ className = 'h-4 w-4', variant = 'other' }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
      strokeLinejoin='round'
      className={className}
    >
      {pathsByVariant[variant] ?? pathsByVariant.other}
    </svg>
  );
}

IndustryIcon.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
};

export default IndustryIcon;
